import {createSelector} from "reselect";

const selectCar = state => state.cars;

export const selectCarsData = createSelector(
    [selectCar],
    cars => cars.carsData
);
export const selectSelectedCarInfo = createSelector(
    [selectCar],
    cars => cars.selectedCarInfo
);
export const selectReports = createSelector(
    [selectCar],
    cars => cars.reports
);
export const selectDay = createSelector(
    [selectCar],
    cars => cars.day
);

export const selectSingleCarData = createSelector(
    [selectCar],
    cars => cars.selectedSingleCar
);
export const selectCarIcons = createSelector(
    [selectCar],
    cars => cars.Icon
);
export const selectPlayPause = createSelector(
    [selectCar],
    cars => cars.playPause
);
export const selectInterval = createSelector(
    [selectCar],
    cars => cars.interval
);
export const selectReportIndex = createSelector(
    [selectCar],
    cars => cars.reportIndex
);
export const selectReportSpeed = createSelector(
    [selectCar],
    cars => cars.reportSpeed
);

export const selectArrowIcon = createSelector(
    [selectCar],
    cars => cars.ArrowIcon
);

export const selectStartRepTime = createSelector(
    [selectCar],
    cars => cars.startRepTime
);
export const selectEndRepTime = createSelector(
    [selectCar],
    cars => cars.endRepTime
);
export const selectHoldOverCars = createSelector(
    [selectCar],
    cars => cars.holdoverCars
);
export const selectAllDeviceInfo = createSelector(
    [selectCar],
    cars => cars.allDeviceInfo
);
export const selectIsWithOutPoint = createSelector(
    [selectCar],
    cars => cars.isWithOutPoint
);
